import { render, staticRenderFns } from "./PayDashboard.vue?vue&type=template&id=3d792b9f&scoped=true"
import script from "./PayDashboard.vue?vue&type=script&lang=js"
export * from "./PayDashboard.vue?vue&type=script&lang=js"
import style0 from "./PayDashboard.vue?vue&type=style&index=0&id=3d792b9f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d792b9f",
  null
  
)

export default component.exports